import { Component } from '@angular/core';

@Component({
  selector: 'app-billing-detail-base-item',
  templateUrl: './billing-detail-base-item.component.html',
  styleUrls: ['./billing-detail-base-item.component.scss'],
})
export class BillingDetailBaseItemComponent {}
